// Stat-tile row over the FILTERED selection (recomputes on every filter click).
import React from 'react';

const Tile = ({ value, label, sub }) => (
  <div className="safety-tile">
    <div className="safety-tile-value">{value ?? '—'}</div>
    <div className="safety-tile-label">{label}</div>
    {sub && <div className="safety-tile-sub">{sub}</div>}
  </div>
);

export default function SummaryStats({ stats, analysis }) {
  if (!stats) return null;
  const sev = stats.bySeverity || {};
  return (
    <div className="safety-tiles">
      <Tile value={stats.nCrashes} label="Crashes (filtered)"
        sub={`${stats.nAnimal} animal strikes`} />
      <Tile value={stats.crashesPerMile} label="Crashes / mile" />
      <Tile value={`${sev.fatal || 0} / ${sev.injury || 0} / ${sev.pdo || 0}`}
        label="Fatal / Injury / PDO" />
      <Tile value={stats.runCount} label={`${analysis} deficiency runs`}
        sub={`${stats.runMiles} mi (${stats.runShareOfCorridor ?? '—'}% of corridor)`} />
      <Tile value={stats.nearShare !== null ? `${stats.nearShare}%` : '—'}
        label="Crashes near a run"
        sub={`within ${stats.nearBufferMi} mi · ${stats.crashesInsideRuns} inside`} />
      {(analysis === 'GLR' || analysis === 'ALL') && (
        <Tile value={stats.nGlareMatched} label="Glare-time matches"
          sub="crash time inside impact ranges" />
      )}
      {(analysis === 'FSA' || analysis === 'ALL') && (
        <Tile value={stats.nWetSurface} label="Wet / snow surface"
          sub="drainage-relevant crashes" />
      )}
      {analysis === 'ALL' && (
        <Tile value={stats.nEmbankment} label="Embankment / overturn"
          sub="GRW signature crashes" />
      )}
    </div>
  );
}
